import { fmtMoney, fmtDate } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ArrowUpDown } from "lucide-react";

const SortHead = ({ label, field, onToggleSort, className = "" }) => (
  <TableHead className={`cursor-pointer ${className}`} onClick={() => onToggleSort(field)}>
    <span className={`flex items-center gap-1 ${className.includes("text-right") ? "justify-end" : ""}`}>
      {label} <ArrowUpDown className="h-3 w-3" />
    </span>
  </TableHead>
);

export const CustomersTable = ({ data, loading, onToggleSort, onRowClick }) => (
  <Card className="shadow-sm">
    <CardContent className="p-0">
      <Table data-testid="customers-table">
        <TableHeader>
          <TableRow>
            <SortHead label="Name" field="name_lc" onToggleSort={onToggleSort} />
            <TableHead>Email</TableHead>
            <TableHead className="hidden md:table-cell">City</TableHead>
            <SortHead label="Orders" field="order_count" onToggleSort={onToggleSort} className="text-right" />
            <SortHead label="Lifetime total" field="lifetime_spend" onToggleSort={onToggleSort} className="text-right" />
            <SortHead label="Last purchase" field="last_purchase" onToggleSort={onToggleSort} className="text-right hidden sm:table-cell" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading && data.items.length === 0 ? (
            <TableRow><TableCell colSpan={6} className="text-center py-10 text-muted-foreground">Loading…</TableCell></TableRow>
          ) : data.items.length === 0 ? (
            <TableRow><TableCell colSpan={6} className="text-center py-10 text-muted-foreground" data-testid="no-customers-message">No customers match your search.</TableCell></TableRow>
          ) : (
            data.items.map((c) => (
              <TableRow
                key={c.id}
                className="cursor-pointer hover:bg-secondary/50"
                onClick={() => onRowClick(c)}
                data-testid={`customer-row-${c.id}`}
              >
                <TableCell className="py-4 font-medium">{c.first_name} {c.last_name}</TableCell>
                <TableCell className="text-muted-foreground">{c.email || "—"}</TableCell>
                <TableCell className="hidden md:table-cell text-muted-foreground">{c.address?.city || "—"}{c.address?.state ? `, ${c.address.state}` : ""}</TableCell>
                <TableCell className="text-right">{c.order_count}</TableCell>
                <TableCell className="text-right font-medium">{fmtMoney(c.lifetime_spend)}</TableCell>
                <TableCell className="text-right hidden sm:table-cell text-muted-foreground">{fmtDate(c.last_purchase)}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);
